import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateContractFiscalDetailsSchema } from '@/features/privateCompanies/schemas/contract/updateFiscalDetails.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractFiscalDetails {
  contractId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractFiscalDetails = ({ contractId, onSuccess, onError }: UseUpdateContractFiscalDetails) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractFiscalDetails'],
    mutationFn: async (data: UpdateContractFiscalDetailsSchema) => {
      const contract = {
        fiscal_document_requirement: data.contract?.fiscal_document_requirement?.value || undefined,
        fiscal_document_consumer: data.contract?.fiscal_document_consumer?.value || undefined,
      }

      await privateAxios.put(`/client/contracts/${contractId}/update_fiscal_data_information`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
